import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapMode = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 35,
	viewBox: "6 2 16 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 10.0469,
			y: 8.96973,
			width: 12,
			height: 12,
			rx: 6,
			transform: "rotate(27.0741 10.0469 8.96973)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.0859,
			y: 2.27539,
			width: 2,
			height: 32.1465,
			transform: "rotate(27.0741 19.0859 2.27539)",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgMapMode);
export { ForwardRef as ReactComponent };
